import React from 'react'
import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import { CMSState } from '../../../../cms/blocks/types.gen'
import { getImageAttribute } from '../../../utils/extra_images.mod'
import { WordPress } from '../../../../wordpress/wordpress_api'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import 'intersection-observer'


export type HeaderAttributes = {
  blockName: 'vidda/header'
  title: string
  intro?: string
  image?: WordPress.MediaResponse
}

export interface HeaderInterface {
  blockName: 'vidda/header'
  attrs: HeaderAttributes
}

export type HeaderBlockProps<extra_images> = HeaderAttributes

export type HeaderBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  intro_classname: string
  visual_classname: string
}>

type HeaderType = 'home' | 'primary'

export function HeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    
    // Throught the template dropdown in the CMS the user can select homepage, to render the header differently
    let header_type: HeaderType = public_state.page.custom_page_data.v.kind == 'r' &&
      public_state.page.custom_page_data.v.v.post.type == 'page' &&
      public_state.page.custom_page_data.v.v.post.template == 'home' ? 'home' : 'primary'

    return mk_widget({
      run: _ => (
        header_type == 'home' ? homepageHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) : 
          primaryHeaderBlock<customBlockData, extra_images>(props, options)(s)(public_state).run(_ => { }) 
      )
    })
  }
}

export function primaryHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: _ => (
        <header
            className={`hero hero--primary hero--${props.image && props.image.media_details ? "image" : "text"}`}
          >
            <div className="hero__inner">
              <div className="hero__content container--xl grid--gutter">
                <div className="hero__content-inner grid--gutter">
                  {(props.title || props.intro) &&
                    <div className="hero__header">
                      {props.title && <h1 className="hero__title typo--3xl">{props.title}</h1>}
                      {props.intro && (
                        <div className="hero__intro text--styled" dangerouslySetInnerHTML={{ __html: props.intro }} />
                      )}
                    </div>
                  }
                </div>
              </div>
              <div className="hero__visual">
                {props.image && props.image.media_details ? 
                  <img
                    src={getImageAttribute(props.image, "page_header", "source_url")}
                    width={getImageAttribute(props.image, "page_header", "width")}
                    height={getImageAttribute(props.image, "page_header", "height")}
                    className="hero__image"
                    alt={props.image.alt_text ? props.image.alt_text : ""}
                    /> 
                  : <div className="hero__placeholder"></div>
                }
              </div>
            </div>
        </header>
      )
    })
  }
}


export function homepageHeaderBlock<customBlockData, extra_images>(
  props: HeaderBlockProps<extra_images>,
  options?: { style: HeaderBlockStyle; key?: string }


): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) => {
    return mk_widget({
      run: (_) => (
        <header className="hero hero--home">
          <div className="hero__inner grid--block container container--xl">
            {(props.title || props.intro) &&
              <header className="hero__header">
                {props.title && <h1 className="hero__title typo--4xl">{props.title}</h1>}
                {props.intro && <div className="hero__intro" dangerouslySetInnerHTML={{ __html: props.intro }} />}
              </header>
            }
            <svg className="hero__icon" width="24" height="32" viewBox="0 0 24 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4V28" stroke="#0094D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M20 20L12 28L4 20" stroke="#0094D9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </header>
      ),
    })
  }
}
